module.exports = __webpack_public_path__ + "img/service-tongyizhifu3.954fa217.svg";